export enum ESkeletonType {
  Unknown = '',
  Input = 'input',
  Textarea = 'textarea',
  Button = 'button',
  Select = 'select',
  ButtonIcon = 'button-icon',
  ButtonCompact = 'button-compact',
  Checkbox = 'checkbox',
  Radio = 'radio',
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  Paragraph = 'paragraph',
}
